import {ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit} from '@angular/core';
import {GeometryObject} from 'geojson';
import {MapElement} from '../../../../shared/map/map-element.model';
import {Subject} from 'rxjs';
import {BaseComponent} from '../../../../components/general/base/base.component';

@Component({
  selector: 'qm-vrgroup-station-info',
  templateUrl: './station-info.component.html',
  styleUrls: ['./station-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StationInfoComponent extends BaseComponent implements OnInit, OnDestroy {

  public station: any;
  /**
   * Currently selected feature
   */
  @Input()
  public currentFeature: MapElement<GeometryObject>;
  /**
   * Subscription manager
   * @type {Subject<any>}
   */
  private ngUnsubscribe: Subject<void> = new Subject();

  /**
   * Default constructor, inject dependencies.
   */
  constructor() {
    super();
    this.name = StationInfoComponent.getComponentName();
  }

  private static getComponentName(): string {
    return 'StationInfo';
  }

  ngOnInit() {
    this.featureChanged();
  }

  featureChanged() {
    if (this.currentFeature) {
      console.log('STATION INFO', this.currentFeature.properties);
      this.station = {
        title: this.currentFeature.properties.nimi,
        short: this.currentFeature.properties.lyhenne
      };
    }
  }

  /**
   * Angular destructor hook
   */
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
